import React from "react";
import classNames from "classnames";

const Fields = ({ children, className }) => (
  <div className={classNames("section__wrapper--fields", className)}>
    {children}
  </div>
);

export default Fields;
